import { createDataTool } from "./data-tool-app.js";
import { csvToJson } from "./csv-to-json-core.js";
import "./data-tool.css";

createDataTool({
  inputLabel: "CSV",
  outputLabel: "JSON",
  extensions: ["csv"],
  defaultFileName: "data.csv",
  exampleFileName: "people.csv",
  example: "name,language,active\nAda,Analytical Engine,true\nGrace,COBOL,true",
  outputExtension: "json",
  mimeType: "application/json",
  suffix: "converted",
  transform(source) {
    return csvToJson(source, {
      headerRow: document.getElementById("dataToolHeaderRow")?.checked ?? true,
      detectTypes: document.getElementById("dataToolDetectTypes")?.checked ?? false,
      indentation: document.getElementById("dataToolIndentation")?.value || 2
    });
  },
  successMessage: result => `Converted ${result.records.toLocaleString("en-US")} rows across ${result.columns.toLocaleString("en-US")} columns.`
});
